import { SiteSlugEnum } from '@/constants/siteSlug.enum'
import EnvUtils from '@/utils/design-system/envUtils'

const getSiteSlug = (): SiteSlugEnum | undefined => {
  if (EnvUtils.isServer()) return undefined
  return window && (window?.location?.hostname?.split('-')?.[0] as SiteSlugEnum)
}

const convertWhiteLabel = () => {
  const siteSlug = getSiteSlug()
  switch (siteSlug) {
    case SiteSlugEnum.NeomHospital:
      return siteSlug
    default:
      return 'default'
  }
}

export const WhiteLabelUtil = {
  getSiteSlug,
  convertWhiteLabel
}
